import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const OcrToolPage = ({ setPage }) => {
  const [file, setFile] = useState(null);
  const [text, setText] = useState('');
  const [err, setErr] = useState('');

  const run = async () => {
    if (!file) return;
    setErr(''); setText('');
    try {
      const fd = new FormData(); fd.append('file', file);
      const res = await fetch(`${API_BASE}/api/ocr/extract`, { method:'POST', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || data.error || 'Failed');
      setText(data.text || '');
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={ui.container}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>OCR Image/PDF to Text</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <label style={ui.label}>Input File</label>
      <div style={{display:'flex', gap:10}}>
      <input type='file' accept='.pdf,image/*' onChange={(e)=>setFile(e.target.files?.[0]||null)} style={ui.fileInput} />
      <button onClick={run} style={ui.primaryBtn}>Extract Text</button>
      </div>
      {err && <div style={ui.error}>{err}</div>}
      <textarea value={text} readOnly rows={16} style={{...ui.textarea, ...ui.mono, marginTop:12}} />
    </div>
  </div></main>;
};

export default OcrToolPage;
